module.exports = __webpack_public_path__ + "img/skirt-detail-top.8199638d.jpg";